export const DTI = 'DTI';
export const VANTAGE_SCORE = 'VANTAGE_SCORE';
